import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { ContentDestinations } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/contentdestinations/@mediaId/download`,
    params: {} as { mediaId: string },
    request: {} as ContentDestinations.Post.Download,
    response: {} as ContentDestinations.Post.Response.Download,
    method: HTTP_METHODS.POST,
  },
};

export const id = {};
